import { RefObject, useState } from "react"
import debounce from "lodash/debounce"

import { useIsomorphicLayoutEffect } from "./use-isomorphic-layout-effect"

export function useContainerQuery(
  ref: RefObject<HTMLElement | null>,
  width: number
): boolean | undefined {
  const [matches, setMatches] = useState<boolean | undefined>(undefined)

  useIsomorphicLayoutEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }

    const currentWidth = element.getBoundingClientRect().width
    if (currentWidth > 0) {
      setMatches(currentWidth >= width)
    }

    const resizeObserver = new ResizeObserver(
      debounce((entries) => {
        for (const entry of entries) {
          const matchesWidth = entry.contentRect.width >= width
          setMatches(matchesWidth)
        }
      })
    )

    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [ref.current, width])

  return matches
}
